import { fromJS } from 'immutable';
import { merger } from 'helpers/HelperFunctions';

const RATE_SUCCESS = 'twineApp/briefDetails/RATE_SUCCESS';
export const SET_ENTITIES = 'twineApp/entities/SET_ENTITIES';
export const UPDATE_BRIEF_SAVED_STATUS =
  'twineApp/entities/UPDATE_BRIEF_SAVED_STATUS';
// Keep in sync with auth.updateLocal — optimistic portfolio media must hit entities.
const UPDATELOCAL = 'twineApp/auth/UPDATELOCAL';

const initialState = {
  briefs: {},
  invites: {},
  credits: {},
  projects: {},
  projectComments: {},
  roles: {},
  testimonials: {},
  users: {},
  vouchers: {},
  bills: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ENTITIES:
    case UPDATELOCAL: {
      const entities =
        action.type === UPDATELOCAL
          ? action.result && action.result.entities
          : action.entities;
      if (entities) {
        const imState = fromJS(state);

        // const imResult = imState.mergeDeep(fromJS(action.entities));

        // return imResult.toJS();

        return merger(imState, fromJS(entities)).toJS();
      }
      break;
    }
    case UPDATE_BRIEF_SAVED_STATUS:
      if (state.briefs && state.briefs[action.jobId]) {
        return {
          ...state,
          briefs: {
            ...state.briefs,
            [action.jobId]: {
              ...state.briefs[action.jobId],
              saved_by_current_user: action.isSaved,
              ...(action.pipelineEntryId !== undefined
                ? { pipeline_entry_id: action.pipelineEntryId }
                : null),
            },
          },
        };
      }
      return state;
    case RATE_SUCCESS:
      return {
        ...state,
        briefs: {
          ...state.briefs,
          [action.result.for_id]: {
            ...state.briefs[action.result.for_id],
            rating: action.result,
          },
        },
      };

    default:
      return state;
  }

  return state;
}

export function get(globalState, type, id) {
  if (!globalState || !type || !id) {
    return null;
  }

  return globalState.entities[type][id] || null;
}

// export function update(type, id, update = {}) {

// }
export function updateBriefSavedStatus(
  jobId,
  isSaved,
  pipelineEntryId = undefined
) {
  return {
    type: UPDATE_BRIEF_SAVED_STATUS,
    jobId,
    isSaved,
    pipelineEntryId,
  };
}
